import PropTypes from 'prop-types';

import { TABLE_HEADERS } from './constants';
import { SheetColumn, SheetTitle, HeaderRow, BodyRow, Footer, FormRow, Group } from './styles';
import useCalculator from './useCalculator';
import useLumberDeckingPdf from './useLumberDeckingPdf';
import Button from '../../ComponentLibrary/oc-button';
import Table from '../../ComponentLibrary/oc-table';

const LumberDeckingSheet = () => {
  const { result } = useCalculator();
  const { generatePdf } = useLumberDeckingPdf();

  return (
    <SheetColumn>
      <SheetTitle>Take Off Sheet</SheetTitle>
      <Table>
        <thead>
          <HeaderRow>
            {TABLE_HEADERS.map(header => (
              <th key={header}>{header}</th>
            ))}
          </HeaderRow>
        </thead>
        <tbody>
          {Object.keys(result).map(type => (
            <BodyRow key={type}>
              <td className="capitalized">{type}</td>
              <td>{result[type].size || '--'}</td>
              <td>{result[type].length || '--'}</td>
              <td>{result[type].quantity || '--'}</td>
              <td>{result[type].overage || '--'}</td>
              <td>{result[type].total || '--'}</td>
            </BodyRow>
          ))}
        </tbody>
      </Table>
      <FormRow noMargin>
        <Group wrapOnMobile>
          <Button onClick={generatePdf}>
            <i className="fa fa-file-pdf-o" aria-hidden="true" />
            &nbsp;&nbsp;&nbsp;Download PDF
          </Button>
        </Group>
      </FormRow>
      <Footer>
        <p>Footnotes:</p>
        <ul>
          <li>Overage includes blocking</li>
          <li>Decking is presumed to be spaced 3/16&quot;</li>
          <li>Overage for decking is 20%</li>
          <li>Overage for Structural Framing is 15%</li>
        </ul>
        <p>Standard board lengths are 12&apos;, 16&apos;, 20&apos; & 24&apos;</p>
        <p>
          Stairs and stair stringers are not included within this takeoff. Please see{' '}
          <a href="https://owenscorning.com/dms/10026715" target="_blank" rel="noreferrer">
            install guide
          </a>{' '}
          for information on stairs
        </p>
        <p>
          Depending on the handrail system being used, ensure adequate blocking per handrail manufacturer recommendation
          or follow AWC DCA-6 for handrail attachment
        </p>
        <p>
          The material estimates provided by the Material Takeoff are intended for informational purposed only. These
          values are approximations and should not be considered as final or binding. It is the responsibility of the
          builder to verify all quantities and specifications before placing any orders. Owens Corning assumes no
          liability for any discrepancies or errors in the estimates. Use of this estimator is at the user’s own risk.
        </p>
      </Footer>
    </SheetColumn>
  );
};

LumberDeckingSheet.propTypes = {
  result: PropTypes.shape({
    joist: PropTypes.shape({
      size: PropTypes.string,
      length: PropTypes.string,
      overage: PropTypes.string,
      quantity: PropTypes.string,
    }),
    rim: PropTypes.shape({
      size: PropTypes.string,
      length: PropTypes.string,
      overage: PropTypes.string,
      quantity: PropTypes.string,
    }),
    ledger: PropTypes.shape({
      size: PropTypes.string,
      length: PropTypes.string,
      overage: PropTypes.string,
      quantity: PropTypes.string,
    }),
    deck: PropTypes.shape({
      size: PropTypes.string,
      length: PropTypes.string,
      overage: PropTypes.string,
      quantity: PropTypes.string,
    }),
    beams: PropTypes.shape({
      size: PropTypes.string,
      length: PropTypes.string,
      overage: PropTypes.string,
      quantity: PropTypes.string,
    }),
    posts: PropTypes.shape({
      size: PropTypes.string,
      length: PropTypes.string,
      overage: PropTypes.string,
      quantity: PropTypes.string,
    }),
  }).isRequired,
};

export default LumberDeckingSheet;
